// Notifications redux actions.
//
// One file holds the action types + creators for the entire feature
// (list, mark-read, preferences, real-time SSE, settings catalog).
// Mirrors the marketplace/listings.js pattern but consolidated since
// the surface is small.

const ns = 'NOTIFICATIONS';

// ---- list / read state ---------------------------------------------------

export const LIST_REQUEST  = ns + '_LIST_REQUEST';
export const LIST_RESPONSE = ns + '_LIST_RESPONSE';
export const LIST_FAILURE  = ns + '_LIST_FAILURE';

export const MARK_READ_REQUEST  = ns + '_MARK_READ_REQUEST';
export const MARK_READ_SUCCESS  = ns + '_MARK_READ_SUCCESS';
export const MARK_READ_FAILURE  = ns + '_MARK_READ_FAILURE';

export const MARK_ALL_READ_REQUEST = ns + '_MARK_ALL_READ_REQUEST';
export const MARK_ALL_READ_SUCCESS = ns + '_MARK_ALL_READ_SUCCESS';
export const MARK_ALL_READ_FAILURE = ns + '_MARK_ALL_READ_FAILURE';

// ---- preferences (Settings page) ----------------------------------------

export const PREFS_CATALOG_REQUEST  = ns + '_PREFS_CATALOG_REQUEST';
export const PREFS_CATALOG_RESPONSE = ns + '_PREFS_CATALOG_RESPONSE';
export const PREFS_CATALOG_FAILURE  = ns + '_PREFS_CATALOG_FAILURE';

export const PREFS_FETCH_REQUEST    = ns + '_PREFS_FETCH_REQUEST';
export const PREFS_FETCH_RESPONSE   = ns + '_PREFS_FETCH_RESPONSE';
export const PREFS_FETCH_FAILURE    = ns + '_PREFS_FETCH_FAILURE';

export const PREFS_UPDATE_REQUEST   = ns + '_PREFS_UPDATE_REQUEST';
export const PREFS_UPDATE_SUCCESS   = ns + '_PREFS_UPDATE_SUCCESS';
export const PREFS_UPDATE_FAILURE   = ns + '_PREFS_UPDATE_FAILURE';

// ---- delivery channel endpoints (Slack / Teams / PagerDuty / webhook) ----

export const CHANNELS_FETCH_REQUEST  = ns + '_CHANNELS_FETCH_REQUEST';
export const CHANNELS_FETCH_RESPONSE = ns + '_CHANNELS_FETCH_RESPONSE';
export const CHANNELS_FETCH_FAILURE  = ns + '_CHANNELS_FETCH_FAILURE';

export const CHANNEL_SAVE_REQUEST    = ns + '_CHANNEL_SAVE_REQUEST';   // create or update
export const CHANNEL_SAVE_SUCCESS    = ns + '_CHANNEL_SAVE_SUCCESS';
export const CHANNEL_SAVE_FAILURE    = ns + '_CHANNEL_SAVE_FAILURE';

export const CHANNEL_DELETE_REQUEST  = ns + '_CHANNEL_DELETE_REQUEST';
export const CHANNEL_DELETE_SUCCESS  = ns + '_CHANNEL_DELETE_SUCCESS';
export const CHANNEL_DELETE_FAILURE  = ns + '_CHANNEL_DELETE_FAILURE';

export const CHANNEL_TEST_REQUEST    = ns + '_CHANNEL_TEST_REQUEST';
export const CHANNEL_TEST_RESULT     = ns + '_CHANNEL_TEST_RESULT';

// ---- real-time SSE -------------------------------------------------------
// The saga maintains the EventSource connection. ``CONNECT`` /
// ``DISCONNECT`` are commands the rest of the app dispatches at
// login / logout. ``RECEIVED`` is dispatched by the saga every time
// a server-sent event lands - the reducer prepends it to ``items``
// and bumps ``unreadCount`` so the bell badge updates with no
// further round-trip.

export const SSE_CONNECT    = ns + '_SSE_CONNECT';
export const SSE_DISCONNECT = ns + '_SSE_DISCONNECT';
export const SSE_STATUS     = ns + '_SSE_STATUS';   // connecting/open/closed
export const RECEIVED       = ns + '_RECEIVED';

// ---- creators ------------------------------------------------------------

export const fetchList         = (params)       => ({ type: LIST_REQUEST, payload: params });
export const fetchListResponse = (payload)      => ({ type: LIST_RESPONSE, payload });
export const fetchListFailure  = (payload)      => ({ type: LIST_FAILURE, payload });

export const markRead          = (id)           => ({ type: MARK_READ_REQUEST, payload: { notification_id: id } });
export const markReadSuccess   = (id)           => ({ type: MARK_READ_SUCCESS, payload: { notification_id: id } });
export const markReadFailure   = (e)            => ({ type: MARK_READ_FAILURE, payload: e });

export const markAllRead       = ()             => ({ type: MARK_ALL_READ_REQUEST });
export const markAllReadDone   = ()             => ({ type: MARK_ALL_READ_SUCCESS });
export const markAllReadFail   = (e)            => ({ type: MARK_ALL_READ_FAILURE, payload: e });

export const fetchCatalog      = ()             => ({ type: PREFS_CATALOG_REQUEST });
export const fetchCatalogOk    = (p)            => ({ type: PREFS_CATALOG_RESPONSE, payload: p });
export const fetchCatalogErr   = (e)            => ({ type: PREFS_CATALOG_FAILURE, payload: e });

export const fetchPreferences  = ()             => ({ type: PREFS_FETCH_REQUEST });
export const fetchPreferencesOk = (p)           => ({ type: PREFS_FETCH_RESPONSE, payload: p });
export const fetchPreferencesErr = (e)          => ({ type: PREFS_FETCH_FAILURE, payload: e });

export const updatePreferences = (events)       => ({ type: PREFS_UPDATE_REQUEST, payload: { events } });
export const updatePreferencesOk = (p)          => ({ type: PREFS_UPDATE_SUCCESS, payload: p });
export const updatePreferencesErr = (e)         => ({ type: PREFS_UPDATE_FAILURE, payload: e });

export const fetchChannels     = ()             => ({ type: CHANNELS_FETCH_REQUEST });
export const fetchChannelsOk   = (p)            => ({ type: CHANNELS_FETCH_RESPONSE, payload: p });
export const fetchChannelsErr  = (e)            => ({ type: CHANNELS_FETCH_FAILURE, payload: e });

// ``channel_id`` present -> PUT update; absent -> POST create.
export const saveChannel       = (channel)      => ({ type: CHANNEL_SAVE_REQUEST, payload: channel });
export const saveChannelOk     = (p)            => ({ type: CHANNEL_SAVE_SUCCESS, payload: p });
export const saveChannelErr    = (e)            => ({ type: CHANNEL_SAVE_FAILURE, payload: e });

export const deleteChannel     = (id)           => ({ type: CHANNEL_DELETE_REQUEST, payload: { channel_id: id } });
export const deleteChannelOk   = (id)           => ({ type: CHANNEL_DELETE_SUCCESS, payload: { channel_id: id } });
export const deleteChannelErr  = (e)            => ({ type: CHANNEL_DELETE_FAILURE, payload: e });

export const testChannel       = (id)           => ({ type: CHANNEL_TEST_REQUEST, payload: { channel_id: id } });
export const testChannelResult = (id, result)   => ({ type: CHANNEL_TEST_RESULT, payload: { channel_id: id, ...result } });

export const sseConnect        = ()             => ({ type: SSE_CONNECT });
export const sseDisconnect     = ()             => ({ type: SSE_DISCONNECT });
export const sseStatus         = (status)       => ({ type: SSE_STATUS, payload: status });
export const notificationReceived = (n)         => ({ type: RECEIVED, payload: n });
